import { render, staticRenderFns } from "./custom_prompt.vue?vue&type=template&id=1ead2ae8&scoped=true"
import script from "./custom_prompt.vue?vue&type=script&lang=js"
export * from "./custom_prompt.vue?vue&type=script&lang=js"
import style0 from "./custom_prompt.vue?vue&type=style&index=0&id=1ead2ae8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead2ae8",
  null
  
)

export default component.exports